import { generate } from '@ant-design/colors';
import genControlHeight from '../shared/genControlHeight';
import genSizeMapToken from '../shared/genSizeMapToken';
import { defaultPresetColors } from '../seed';
import genColorMapToken from '../shared/genColorMapToken';
import genCommonMapToken from '../shared/genCommonMapToken';
import { generateColorPalettes, generateNeutralColorPalettes } from './colors';
import genFontMapToken from '../shared/genFontMapToken';
export default function derivative(token) {
    const colorPalettes = Object.keys(defaultPresetColors)
        .map((colorKey) => {
        const colors = generate(token[colorKey]);
        return new Array(10).fill(1).reduce((prev, _, i) => {
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    })
        .reduce((prev, cur) => {
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), genColorMapToken(token, {
        generateColorPalettes,
        generateNeutralColorPalettes,
    })), genFontMapToken(token.fontSize)), genSizeMapToken(token)), genControlHeight(token)), genCommonMapToken(token));
}
